import { GET } from "../../API/get";

export const fetchFtmsRatings = async (current_page, serach_text, sort_key, sort_direction, start_date, end_date) => {
    let url = `ftms/ratings/${current_page}?search=${serach_text.trim()}&sort_key=${sort_key}&sort_direction=${sort_direction}`;

    if(start_date && end_date) {
        url += `&start_date=${start_date}&end_date=${end_date}`;
    }

    const response = await GET(url);
    return response.status === "Success" ? response : null;
}

export const filterDate = (data, reset, dispatch) => {
    if(data.start_date === '' && data.end_date === ''){
        dispatch({
            type: "SET_ERROR",
            error: 'Please select start date and end date.'
        });
    }else{
        if(data.start_date === ''){
            dispatch({
                type: "SET_ERROR",
                error: 'Please select start date.'
            });
        }else{
            if(data.end_date === ''){
                dispatch({
                    type: "SET_ERROR",
                    error: 'Please select end date.'
                });
            }else{
                dispatch({
                    type: "SET_ERROR",
                    error: null
                });
                reset();
                dispatch({
                    type: 'SET_DATE_RANGE',
                    start_date: data.start_date,
                    end_date: data.end_date
                });
            }
        }
    }
}